{
  "message": "Bitte bestätigen Sie Ihre E-Mail-Adresse. Danach prüft eine Administratorin oder ein Administrator Ihr Konto. Wir senden Ihnen die Entscheidung per E-Mail. Nach der Freigabe können Sie sich anmelden.",
  "title": "Ihr Konto ist noch nicht aktiv",
  "waitsFor": {
    "approval": "Eine Administratorin oder ein Administrator muss Ihr Konto noch freigeben. Danach können Sie sich anmelden.",
    "confirm_email": "Bestätigen Sie Ihre E-Mail-Adresse über den Link, den wir Ihnen geschickt haben. Danach können Sie sich anmelden.",
    "confirm_email_then_approval": "Bestätigen Sie Ihre E-Mail-Adresse über den Link, den wir Ihnen geschickt haben. Danach gibt eine Administratorin oder ein Administrator Ihr Konto frei."
  }
}
